import { ComponentFactoryResolver, ComponentRef, Injectable, Injector } from '@angular/core';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { DynamicContentOutletErrorComponent } from './components/dynamic-content-outlet-error/dynamic-content-outlet-error.component'; // Reference directly rather than barrel avoid circular reference.
import { DynamicOutletRegistryService } from './dynamic-outlet.registry';
import { ModuleLoaderService } from './module-loader.service';

@Injectable({
  providedIn: 'root'
})
export class DynamicOutletService {

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private moduleLoaderService: ModuleLoaderService,
    private registryService: DynamicOutletRegistryService,
    private injector: Injector) { }

  async getComponent(componentName: string, localInjector: Injector): Promise<ComponentRef<any>> {

    const component = this.registryService.get(componentName);

    if (component == null) {
      return this.getDynamicContentErrorComponent(
        `Unable to locate ${componentName}`
      );
    }

    var { module, componentType } = component;

    if (module == null) {
      return this.getDynamicContentErrorComponent(
        `Unable to derive modulePath from component: ${componentName}`
      );
    }

    if (componentType == null) {
      return this.getDynamicContentErrorComponent(
        `Unable to derive componentType from component: ${componentName}`
      );
    }

    return this.moduleLoaderService.getOrLoad(module)
      .pipe(
        map(p => {
          if (typeof componentType === 'string') { // Resolve Component Type
            const componentRef = this.registryService.get(componentType);
            if (componentRef == null || typeof componentRef.componentType === 'string') {
              const msg = `Component Type '${componentType}' is not defined`;
              console.warn(msg, componentRef);
              return this.getDynamicContentErrorComponent(msg);
            }
            componentType = componentRef.componentType;
          }

          const componentResolver = p.componentFactoryResolver;
          const componentFactory = componentResolver.resolveComponentFactory(componentType);
          const result = componentFactory.create(localInjector);
          return result;
        }),
        catchError(error => {
          console.error(error.message);
          return of(this.getDynamicContentErrorComponent(
            `Unable to load module ${module}. Looked up using component: ${componentName}. Error Details: ${error.message}`
          ));
        })
      ).toPromise();
  }

  private getDynamicContentErrorComponent(errorMessage: string) {
    const factory = this.componentFactoryResolver.resolveComponentFactory(DynamicContentOutletErrorComponent);
    const componentRef = factory.create(this.injector);
    const instance = <any>componentRef.instance;
    instance.errorMessage = errorMessage;
    return componentRef;
  }

}


